import {
  CmsContentPrivacySchema,
  type CmsContentPrivacyForm,
} from "@/modules/cms/domain/contracts";
import { FormTipTapEditor } from "@/shared/ui/FormTipTapEditor";
import { Button, FormCheckbox, FormRoot, RHF, zodResolver } from "@devhop/ui";
import type { Resolver, UseFormReturn } from "react-hook-form";

type PrivacyFormProps = {
  content: CmsContentPrivacyForm | null;
  onSubmit: (content: CmsContentPrivacyForm) => void;
  onCancel: () => void;
  submitting?: boolean;
};

const defaultContent: CmsContentPrivacyForm = {
  content: {},
  isActive: true,
};

export function PrivacyForm({
  content,
  onSubmit,
  onCancel,
  submitting,
}: PrivacyFormProps) {
  const methods = RHF.useForm<CmsContentPrivacyForm>({
    resolver: zodResolver(
      CmsContentPrivacySchema,
    ) as Resolver<CmsContentPrivacyForm>,
    defaultValues: content ?? defaultContent,
  });

  return (
    <FormRoot<CmsContentPrivacyForm>
      methods={methods as UseFormReturn<CmsContentPrivacyForm>}
      onSubmit={onSubmit}
    >
      <div className="space-y-6">
        <div className="space-y-2">
          <span className="font-medium text-sm">ເນື້ອຫາ (HTML)</span>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <FormTipTapEditor
              name="content.lo"
              label="ລາວ"
              placeholder="ເພີ່ມເນື້ອຫານະໂຍບາຍຄວາມເປັນສ່ວນຕົວ (ລາວ)..."
            />
            <FormTipTapEditor
              name="content.th"
              label="ໄທ"
              placeholder="ເພີ່ມເນື້ອຫານະໂຍບາຍຄວາມເປັນສ່ວນຕົວ (ໄທ)..."
            />
            <FormTipTapEditor
              name="content.en"
              label="EN"
              placeholder="Add privacy policy content (EN)..."
            />
          </div>
        </div>
        <FormCheckbox name="isActive" label="ເປີດໃຊ້ງານ" />
        <div className="flex gap-2 pt-2">
          <Button type="submit" disabled={submitting}>
            {submitting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
          </Button>
          <Button type="button" variant="outline" onClick={onCancel}>
            ຍົກເລີກ
          </Button>
        </div>
      </div>
    </FormRoot>
  );
}
